// Single typed escape hatch for reading Zod's internal `_def`. Centralizes
// the `as any` and lets walker / field-extraction call sites stay readable.
//
// Hoisted from `src/app/screens/library.tsx` at P-025 (D-### form scaffold).
// The form-generator walker at `src/app/form/schema-to-fields.ts` is the
// second consumer; downstream P-026 / P-027 / P-028 field components read
// constraints from `_def` for inline validation hints. Per the project's
// "extract on third use" convention this is the right phase to lift.
//
// Zod 3.x does not expose `_def` in its public type surface even though the
// shape is stable across minor versions. The helper isolates the cast so
// callers don't have to repeat the eslint-disable / `as any` ritual.
//
// Note: `_def` is a Zod 3 implementation detail. If we upgrade to Zod 4,
// re-validate this helper's call sites against the new internal shape.

import type { z } from 'zod'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function zodDef(schema: z.ZodTypeAny): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (schema as any)._def
}
